// Traducciones al inglés: clave = texto en español exactamente como en el código.
// Check-Ins (panel del personal) y kiosko.
export default {
  // Navegación y modos de estación
  'Hoy': 'Today',
  'Salida': 'Check-out',
  'Salida@@botón': 'Check out',
  'Reportes': 'Reports',
  'Autoservicio': 'Self check-in',
  'Atendida': 'Staffed',
  'Lista de salón': 'Room roster',
  'No tienes acceso a ningún campus en Check-Ins': 'You don’t have access to any campus in Check-Ins',

  // Hoy
  'Fecha': 'Date',
  'Niños y visitantes': 'Kids and guests',
  'Voluntarios': 'Volunteers',
  'Aún en el edificio': 'Still in the building',
  'Hay eventos con horario este día que aún no tienen sesiones abiertas.': 'Some events are scheduled for this day but don’t have open sessions yet.',
  'Abrir {name}': 'Open {name}',
  'Sesiones': 'Sessions',
  'No hay sesiones este día': 'No sessions on this day',
  'Evento': 'Event',
  'Horario': 'Time',
  'Estado': 'Status',
  'Niños': 'Kids',
  'Dentro': 'Inside',
  'Cerrada': 'Closed',
  'Abierta': 'Open',
  'Abre {time}': 'Opens {time}',
  'Terminó': 'Ended',

  // Lista por salón
  'Adultos en el auditorio': 'Adults in the auditorium',
  'Lista por salón': 'Room roster',
  'Se actualiza sola cuando alguien entra o sale.': 'Updates automatically when someone checks in or out.',
  'Al cerrar la sesión, los kioskos dejan de aceptar registros para ella.': 'Once the session is closed, kiosks stop accepting check-ins for it.',
  'Sesión cerrada': 'Session closed',
  'Cerrar sesión@@check-ins': 'Close session',
  'Mostrar a quienes ya salieron': 'Show people who already checked out',
  '{n} voluntario': '{n} volunteer',
  '{n} voluntarios': '{n} volunteers',
  '{count} niños': '{count} kids',
  '{n} vol. · 1:{ratio}': '{n} vol. · 1:{ratio}',
  'Nadie registrado.': 'No one checked in.',
  'Voluntario': 'Volunteer',
  'Visita': 'Guest',
  'Entró {in}': 'In {in}',
  'Entró {in} · salió {out}': 'In {in} · out {out}',
  'Conteo manual': 'Headcount',
  'Qué se cuenta': 'What is being counted',
  'Ubicación': 'Location',
  'Toda la sesión': 'Whole session',
  'Cantidad': 'Count',
  'Registrar@@conteo': 'Record',

  // Salida
  'Salida de {name}': 'Check out {name}',
  'Registrar salida': 'Check out',
  'Código de la etiqueta del padre/madre': 'Code on the parent’s label',
  'Salida registrada: {n} niño con el código {code}.': 'Checked out {n} kid with code {code}.',
  'Salida registrada: {n} niños con el código {code}.': 'Checked out {n} kids with code {code}.',
  'No se pudo registrar la salida': 'Couldn’t check out',

  // Reportes
  'Reportes de asistencia': 'Attendance reports',
  'Desde': 'From',
  'Hasta': 'To',
  'Asistencia por evento': 'Attendance by event',
  'Sin datos en el periodo': 'No data for this period',
  'Visitas': 'Guests',
  'Conteos manuales': 'Headcounts',
  'Primera visita ({n})': 'First-time guests ({n})',
  'Nadie nuevo en el periodo': 'No first-time guests in this period',

  // Configuración
  'Configuración de Check-Ins': 'Check-Ins settings',
  'Eventos, horarios, salones y estaciones de cada campus.': 'Events, schedules, rooms and stations for each campus.',
  'Solo un administrador de Check-Ins de este campus puede cambiar la configuración.': 'Only a Check-Ins admin for this campus can change the settings.',
  'Sin eventos': 'No events',
  'Crea un evento como “Niños Domingo”.': 'Create an event such as “Sunday Kids”.',
  'Nuevo evento': 'New event',
  'Nombre del evento (p. ej. Niños Domingo)': 'Event name (e.g. Sunday Kids)',
  'Estaciones': 'Stations',
  'Dispositivo activado': 'Device activated',
  'Sin activar': 'Not activated',
  'Este navegador no permite guardar la activación (modo privado). Usa una ventana normal.': 'This browser can’t save the activation (private mode). Use a regular window.',
  'Activar este dispositivo': 'Activate this device',
  'El dispositivo activado dejará de funcionar como kiosko.': 'The activated device will stop working as a kiosk.',
  'Desactivar@@kiosko': 'Deactivate',
  'Sin estaciones': 'No stations',
  'Nombre (p. ej. Kiosko Lobby)': 'Name (e.g. Lobby Kiosk)',
  'Modo': 'Mode',
  'Crear estación': 'Create station',
  '“Autoservicio”: las familias buscan con su teléfono (no se puede buscar por nombre, por seguridad). “Atendida”: personal con sesión iniciada puede buscar por nombre.':
    '“Self check-in”: families search by phone number (searching by name isn’t allowed, for safety). “Staffed”: signed-in staff can search by name.',
  '{n} mes': '{n} month',
  '{n} meses': '{n} months',
  '{y} años': '{y} years',
  '{y} años {m} m': '{y} yrs {m} mo',
  '¿Archivar el evento {name}?': 'Archive the event {name}?',
  'Horarios semanales': 'Weekly schedule',
  '(abre {n} min antes)': '(opens {n} min before)',
  'Eliminar horario': 'Delete time',
  'Sin horarios.': 'No times.',
  'Día': 'Day',
  'Inicio@@hora': 'Start',
  'Fin': 'End',
  'Salones': 'Rooms',
  'voluntarios': 'volunteers',
  'todas las edades': 'all ages',
  'cupo {n}': 'capacity {n}',
  '¿Archivar el salón {name}?': 'Archive the room {name}?',
  'Salón': 'Room',
  'Nuevo salón': 'New room',
  'Nombre@@salón': 'Name',
  'Salón para voluntarios': 'Volunteer room',
  '¿Quién puede entrar?': 'Who can check in?',
  'Por edad (meses)': 'By age (months)',
  'Por grado escolar': 'By school grade',
  'Cualquiera': 'Anyone',
  'Edad mínima (meses)': 'Minimum age (months)',
  'Edad máxima (meses)': 'Maximum age (months)',
  'Ej.: 0–23 cuna, 24–71 preescolar': 'E.g. 0–23 nursery, 24–71 preschool',
  'Cupo máximo': 'Maximum capacity',
  'Niños por voluntario': 'Kids per volunteer',

  // Kiosko
  'Familia {name}': '{name} Family',
  'Kiosko sin activar': 'Kiosk not activated',
  'Un administrador de Check-Ins debe activar este dispositivo desde Check-Ins → Configuración → “Activar este dispositivo”.':
    'A Check-Ins admin must activate this device from Check-Ins → Settings → “Activate this device”.',
  'Check-In atendido': 'Staffed check-in',
  'Elige la estación': 'Choose a station',
  'No tienes permiso de edición en Check-Ins en ningún campus.': 'You don’t have edit access to Check-Ins at any campus.',
  'Este campus no tiene estaciones. Créalas en Check-Ins → Configuración.': 'This campus has no stations. Create them in Check-Ins → Settings.',
  'Salir del kiosko': 'Exit kiosk',
  'No hay registro abierto en este momento': 'Check-in isn’t open right now',
  'El registro se abre unos minutos antes de cada servicio.': 'Check-in opens a few minutes before each service.',
  'Quitar activación': 'Remove activation',
  'Quitar de este dispositivo': 'Remove from this device',
  'Este dispositivo dejará de funcionar como kiosko hasta que un administrador lo vuelva a activar.': 'This device will stop working as a kiosk until an admin activates it again.',
  'No encontramos a nadie. Pide ayuda a un voluntario.': 'We couldn’t find anyone. Please ask a volunteer for help.',
  'No se pudo buscar': 'Search failed',
  '¡Bienvenidos!': 'Welcome!',
  'Tu teléfono': 'Your phone number',
  'Teléfono o nombre': 'Phone or name',
  'Búsqueda': 'Search',
  'Escribe tu número de teléfono o sus últimos 4 dígitos, o escanea tu tarjeta.': 'Enter your phone number or its last 4 digits, or scan your card.',
  'Busca por teléfono, últimos 4 dígitos, nombre, tarjeta o código de registro previo.': 'Search by phone, last 4 digits, name, card or pre-check code.',
  'Borrar': 'Backspace',
  '¿Cuál es tu familia?': 'Which family is yours?',
  'No se pudo registrar': 'Couldn’t check in',
  '¿Quién viene hoy?': 'Who’s here today?',
  'Toca a cada persona que se registra.': 'Tap each person who is checking in.',
  'Ya está registrado': 'Already checked in',
  'No hay un salón para esta persona': 'There’s no room for this person',
  'Adulto': 'Adult',
  '{event} {time}: ya registrado': '{event} {time}: already checked in',
  'Salón para {name}': 'Room for {name}',
  'No asiste a este horario': 'Not attending this time',
  'Voluntario · {name}': 'Volunteer · {name}',
  'Registrar ({n})': 'Check in ({n})',
  '¡Listo! 🎉': 'All set! 🎉',
  'Tu código para recoger:': 'Your pickup code:',
  'Toma tus etiquetas de la impresora.': 'Grab your labels from the printer.',
  'Guarda la etiqueta del padre/madre para recoger a los niños.': 'Keep the parent label to pick up your kids.',
  'Imprimir de nuevo': 'Print again',
  'Terminar': 'Done',
  'RECOGER A:': 'PICK UP:',
  'Presenta esta etiqueta': 'Show this label',
  "Autorizado": "Authorized",
  "El código no coincide con el de la etiqueta del niño.": "The code doesn’t match the child’s label.",
  "Escribe el código de la etiqueta del padre o madre y confirma quién recoge.": "Enter the code from the parent’s label and confirm who is picking up.",
  "Esta persona no está autorizada para todos los niños. No los entregues: llama a un administrador.": "This person is not authorized for all the children. Don’t release them: call an administrator.",
  "Este niño no tiene adultos del hogar ni personas autorizadas registradas.": "This child has no household adults or authorized people on file.",
  "Nombre completo de quien recoge": "Full name of the person picking up",
  "Otra persona": "Someone else",
  "Quién recoge": "Who is picking up",
  "Se entrega a {n} niño": "Releasing {n} child",
  "Se entregan {n} niños": "Releasing {n} children",
  "Solo para {names}": "Only for {names}",
  "Todos los niños de este código ya salieron": "All children with this code have already been checked out",
  "Verifiqué su identidad y autorizo esta salida como administrador (queda registrado)": "I verified their identity and approve this check-out as an administrator (it will be logged)",
  "Ya salió": "Already out",
  "Etiquetas enviadas a {printer}.": "Labels sent to {printer}.",
  "No se pudo usar {printer} ({reason}). Imprimiendo desde el navegador.": "Couldn’t use {printer} ({reason}). Printing from the browser instead.",
  "ALERTA": "ALERT",
  "La impresora no respondió": "The printer didn’t respond",
  "No se encontró el agente de impresión en esta computadora": "The print agent isn’t running on this computer",
  "La impresora no tiene dirección": "The printer has no address",
  "Etiqueta de prueba · {date}": "Test label · {date}",
  "Imprimiendo en {printer}…": "Printing on {printer}…",
  "+ Impresora": "+ Printer",
  "2.25 × 1.25 in": "2.25 × 1.25 in",
  "4 × 2 in": "4 × 2 in",
  "Agente de impresión en esta computadora": "Print agent on this computer",
  "Conectado": "Connected",
  "Dirección IP": "IP address",
  "Editar impresora": "Edit printer",
  "Etiqueta de prueba enviada a {printer}": "Test label sent to {printer}",
  "Etiqueta {size} in": "{size} in labels",
  "Impresora de la estación": "Station printer",
  "Impresoras": "Printers",
  "Imprimir desde el navegador": "Print from the browser",
  "Imprimir prueba": "Print test",
  "La impresora debe tener IP fija en la red de la iglesia. El puerto de las Zebra es 9100.": "The printer needs a fixed IP on the church network. Zebra printers use port 9100.",
  "Las estaciones que la usan volverán a imprimir desde el navegador.": "Stations using it will go back to printing from the browser.",
  "Navegador (cualquier impresora)": "Browser (any printer)",
  "No encontrado": "Not found",
  "Nombre@@impresora": "Name",
  "Nueva impresora": "New printer",
  "Sin impresoras: las estaciones imprimen desde el navegador.": "No printers: stations print from the browser.",
  "Tamaño de etiqueta": "Label size",
  "Verificando…": "Checking…",
  "Zebra Lobby": "Lobby Zebra",
  "Zebra en red (ZPL)": "Network Zebra (ZPL)",
  "Zebra en red: instala el agente de impresión en cada computadora de kiosko (carpeta apps/print-agent). Otras impresoras de etiquetas: elige «Navegador» y abre Chrome con --kiosk --kiosk-printing para imprimir sin diálogo.": "Network Zebra: install the print agent on each kiosk computer (apps/print-agent folder). Other label printers: choose “Browser” and open Chrome with --kiosk --kiosk-printing to print without a dialog.",
  "Elige al menos una persona.": "Choose at least one person.",
  "El registro de ese horario ya cerró.": "Check-in for that time has closed.",
  "Una persona aparece dos veces en el mismo horario.": "A person appears twice in the same time slot.",
  "No encontramos a esa persona en los datos de este kiosko. Pide ayuda a un voluntario.": "We couldn’t find that person in this kiosk’s data. Ask a volunteer for help.",
  "Ese salón no corresponde a este horario.": "That room doesn’t belong to this time slot.",
  "{name} no corresponde a {location}": "{name} doesn’t belong in {location}",
  "{name} ya está registrado en este horario": "{name} is already checked in for this time slot",
  "Este kiosko ya usó todos sus códigos para registrar sin conexión. Pide ayuda a un voluntario.": "This kiosk has used all of its offline check-in codes. Ask a volunteer for help.",
  "Los datos de este kiosko son de otro día. Conéctalo a internet para registrar.": "This kiosk’s data is from another day. Connect it to the internet to check in.",
  "Sin conexión, y este kiosko todavía no tiene datos guardados para registrar sin internet.": "No connection, and this kiosk doesn’t have saved data for offline check-in yet.",
  "Reintentar": "Try again",
  "Busca con tu número de teléfono o los últimos 4 dígitos": "Search with your phone number or its last 4 digits",
  "Hay más de una familia con esos 4 dígitos. Escribe tu número completo.": "More than one family has those 4 digits. Enter your full number.",
  "Este kiosko no puede guardar registros sin conexión. Pide ayuda a un voluntario.": "This kiosk can’t save check-ins offline. Ask a volunteer for help.",
  "No se pudo guardar el registro en este kiosko. Pide ayuda a un voluntario.": "The check-in couldn’t be saved on this kiosk. Ask a volunteer for help.",
  "Sin conexión. Los registros se guardan en este kiosko y se enviarán cuando vuelva el internet.": "Offline. Check-ins are saved on this kiosk and will be sent when the internet is back.",
  "{n} registro pendiente.": "{n} check-in pending.",
  "{n} registros pendientes.": "{n} check-ins pending.",
  "Enviando {n} registro guardado sin conexión…": "Sending {n} check-in saved offline…",
  "Enviando {n} registros guardados sin conexión…": "Sending {n} check-ins saved offline…",
  "{n} registro hecho sin conexión necesita revisión (Administración → Bitácora).": "{n} offline check-in needs review (Administration → Audit log).",
  "{n} registros hechos sin conexión necesitan revisión (Administración → Bitácora).": "{n} offline check-ins need review (Administration → Audit log).",
  "Hay {n} registro hecho sin conexión que todavía no se envía. Si quitas la activación ahora, se perderá.": "There is {n} offline check-in that hasn’t been sent yet. If you remove the activation now, it will be lost.",
  "Hay {n} registros hechos sin conexión que todavía no se envían. Si quitas la activación ahora, se perderán.": "There are {n} offline check-ins that haven’t been sent yet. If you remove the activation now, they will be lost.",
  "Check-in": "Check-in",
  "Registro previo desde el teléfono": "Pre-check from the phone",
  "Las familias eligen en el portal quién viene y a qué salón (desde 2 horas antes de que abra el registro) y reciben un código QR. Al llegar, el kiosko lee el código e imprime las etiquetas.": "Families choose in the portal who is coming and to which room (starting 2 hours before check-in opens) and get a QR code. When they arrive, the kiosk reads the code and prints the labels.",
  "Sin conexión no se puede leer el registro previo. Busca con tu teléfono.": "The pre-check can’t be read while offline. Search with your phone number.",
  "Escanear código QR": "Scan QR code",
  "Buscar con mi teléfono": "Search with my phone number",
  "Tengo un código": "I have a code",
  "Registro previo desde el teléfono: revisa la selección y confirma para imprimir las etiquetas.": "Pre-check from the phone: review the selection and confirm to print the labels.",
  "Elegido desde el teléfono": "Chosen from the phone",
  "Este dispositivo no permite usar la cámara aquí. Escribe el código.": "This device can’t use the camera here. Type the code.",
  "No hay permiso para usar la cámara. Escribe el código.": "There’s no permission to use the camera. Type the code.",
  "No se pudo abrir la cámara. Escribe el código.": "Couldn’t open the camera. Type the code.",
  "Muestra el código QR a la cámara": "Show the QR code to the camera",
  "Cambiar cámara": "Switch camera",
  "Elige desde aquí quién viene y a qué salón. Al llegar, muestra el código en el kiosko y se imprimen las etiquetas.": "Choose here who is coming and to which room. When you arrive, show the code at the kiosk and the labels will print.",
  "El registro previo no está disponible": "Pre-check isn’t available",
  "Tu iglesia todavía no lo activó. Puedes registrar a tu familia en el kiosko al llegar.": "Your church hasn’t turned it on yet. You can check in your family at the kiosk when you arrive.",
  "No hay horarios abiertos para registro previo": "No times are open for pre-check",
  "El registro previo se abre unas horas antes de cada Reunión.": "Pre-check opens a few hours before each gathering.",
  "Tu código para el kiosko": "Your code for the kiosk",
  "Código QR {code}": "QR code {code}",
  "Al llegar, toca «Escanear código QR» en el kiosko y muestra este código (o escríbelo).": "When you arrive, tap “Scan QR code” at the kiosk and show this code (or type it).",
  "Válido hasta las {time}": "Valid until {time}",
  "¿Cancelar este registro previo? Si vienen, pueden registrarse en el kiosko.": "Cancel this pre-check? If you come, you can check in at the kiosk.",
  "Cancelar registro previo": "Cancel pre-check",
  "Nuevo registro previo": "New pre-check",
  "No hay un salón para tu familia en este horario.": "There’s no room for your family at this time.",
  "Ya tiene registro previo": "Already pre-checked",
  "Esto no registra a nadie todavía: tus hijos quedan registrados cuando el kiosko imprime sus etiquetas.": "This doesn’t check anyone in yet: your children are checked in when the kiosk prints their labels.",
  "Generar código ({n} persona)": "Get code ({n} person)",
  "Generar código ({n} personas)": "Get code ({n} people)",
  "Generar código": "Get code",
  "Check-in de mis hijos": "Check in my kids",
  "Tarjetas": "Cards",
  "Volver a tarjetas": "Back to cards",
  "Imprimir tarjetas": "Print cards",
  "{n} tarjeta": "{n} card",
  "{n} tarjetas": "{n} cards",
  "Formato": "Format",
  "Hoja carta, 10 tarjetas (Avery 5371 / 8371)": "Letter sheet, 10 cards (Avery 5371 / 8371)",
  "Una por etiqueta de 4 × 2 in (impresora de etiquetas)": "One per 4 × 2 in label (label printer)",
  "Imprime al 100 % (sin «ajustar a la página»). Se pueden recortar y enmicar, o pegar en un llavero.": "Print at 100% (no “fit to page”). Cut them out and laminate them, or stick them on a key tag.",
  "Elige la impresora de etiquetas y el tamaño 4 × 2 in en el diálogo de impresión.": "Choose the label printer and the 4 × 2 in size in the print dialog.",
  "Check-In: escanéala en el kiosko": "Check-In: scan it at the kiosk",
  "Tarjetas de Check-In": "Check-In cards",
  "Llaveros o tarjetas con código de barras: al escanearlos en el kiosko aparece toda la familia.": "Key tags or cards with a barcode: scanning one at the kiosk brings up the whole family.",
  "Crear para familias sin tarjeta": "Create for families without a card",
  "Asignar tarjeta": "Assign card",
  "Nombre o código": "Name or code",
  "Imprimir las primeras {n}": "Print the first {n}",
  "Imprimir ({n})": "Print ({n})",
  "Ninguna tarjeta coincide": "No cards match",
  "Todavía no hay tarjetas en este campus": "There are no cards in this campus yet",
  "Asigna el llavero que ya tiene una familia, o crea tarjetas nuevas para todas las familias con niños.": "Assign the key tag a family already has, or create new cards for every family with children.",
  "Seleccionar todas": "Select all",
  "Familia": "Family",
  "La lleva": "Carried by",
  "Creada": "Created",
  "Seleccionar {name}": "Select {name}",
  "¿Quitar la tarjeta {code}? Ya no servirá en el kiosko.": "Remove card {code}? It will no longer work at the kiosk.",
  "Tarjeta {code} asignada a {name}.": "Card {code} assigned to {name}.",
  "Se creó {n} tarjeta. Está seleccionada para imprimir.": "{n} card was created. It’s selected for printing.",
  "Se crearon {n} tarjetas. Están seleccionadas para imprimir.": "{n} cards were created. They’re selected for printing.",
  "Asignar esta tarjeta": "Assign this card",
  "Crear tarjeta nueva": "Create new card",
  "¿Quién la lleva?": "Who carries it?",
  "Código de la tarjeta": "Card code",
  "Escanea el llavero que ya tienen (de otro sistema) o déjalo vacío para crear un código nuevo.": "Scan the key tag they already have (from another system) or leave it empty to create a new code.",
  "Basta una tarjeta por familia: al escanearla aparece todo el hogar.": "One card per family is enough: scanning it brings up the whole household.",
  "Crear tarjetas para familias": "Create cards for families",
  "Crear {n} tarjeta": "Create {n} card",
  "Crear {n} tarjetas": "Create {n} cards",
  "Hay {n} familia con niños en este campus que todavía no tiene tarjeta. Se creará una tarjeta para el primer adulto del hogar.": "There is {n} family with children in this campus that doesn’t have a card yet. A card will be created for the first adult in the household.",
  "Hay {n} familias con niños en este campus que todavía no tienen tarjeta. Se creará una tarjeta para el primer adulto de cada hogar.": "There are {n} families with children in this campus that don’t have a card yet. A card will be created for the first adult in each household.",
  "Todas las familias con niños de este campus ya tienen tarjeta.": "Every family with children in this campus already has a card.",
  "Tarjeta de Check-In": "Check-In card",
  "la lleva {name}": "carried by {name}",
  "Sin tarjeta. En el kiosko pueden buscar con su teléfono.": "No card. At the kiosk they can search with their phone number.",
} satisfies Record<string, string>;
